module.exports = __webpack_public_path__ + "img/bibliography.daf362f3.jpeg";